import Navigation from "root/Navigation";
import ProductDescription from "components/ProductDescription";
import CardContainer from "components/CardContainer";
import * as colors from "config/styles/colors";

function Mainpage(params) {
  return (
    <>
      <Navigation />
      <ProductDescription />
      <div style={{ flex: "1 1 auto", backgroundColor: colors.blackish }} />
      <CardContainer />
      <div style={{ flex: "1 0 2rem", backgroundColor: colors.whiteish }} />
    </>
  );
}

export default Mainpage;
